var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-image',{staticStyle:{"margin-bottom":"-4px","width":"100%"},attrs:{"src":_vm.basicInfo.nav_background?_vm.basicInfo.nav_background:_vm.localUrl,"alt":""}}),_c('headTip'),_c('div',[_c('router-view')],1),_c('footerTip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }